<template>
  <the-page :pageId="pageId" :appConfig="appConfig" class="file-page" embeddedMode>
    <page-block
      :title="title"
      :showExportBtn="showExportBtn"
      :config="appConfig"
      :columns="columns"
      :dataExport="data"
      :btnText="appConfig.data.customprops.downloadReportButton.text"
      :isLoading="!config"
      :exportName="exportName"
      :btns="[{ label: 'Текущая страница XLSX', format: 'xlsx' }]"
    >
      <!-- Селекты на странице -->
      <component-selects
        v-if="date_filtres"
        :variablesType="variablesType"
        :defaultDate="defaultDate"
        @requestFilterData="requestData($event)"
      />
      <!-- Таблица -->
      <div class="file-page__table">
        <!-- Заголовки таблицы -->
        <div class="file-page__table-header">
          <div
            v-for="item in tableHeader"
            :key="item.id"
            :class="[
              { 'file-page__table-header-title': item.tag },
              { 'file-page__wrap-icon': !item.tag },
              item.tag,
            ]"
          >
            {{ item.name }}
          </div>
        </div>
        <!-- Основной контент таблицы -->
        <div class="file-page__table-body">
          <!-- Строки таблицы -->
          <div v-for="(row, rowIndex) in data" :key="rowIndex" class="file-page__table-row">
            <div class="file-page__row-content">
              <!-- Иконка для раскрытия подробной информации -->
              <div class="file-page__wrap-icon" @click="openHelper(rowIndex)">
                <icon-vektor-to-right
                  :class="[
                    'file-page__icon-vektor',
                    {
                      'file-page__icon-vektor_rotate': rowIndex === showHelperIndex,
                    },
                  ]"
                />
              </div>
              <div
                v-for="(col, idx) in tableHeader.slice(1)"
                :key="idx"
                :class="['file-page__column', col.tag]"
              >
                <p v-if="idx === 0" class="file-page__column-text">
                  {{ row[col.tag] }}
                </p>

                <p v-if="idx === 1" class="file-page__column-text">
                  {{ rowIndex === showHelperIndex ? 'Общая статистика' : row[col.tag] }}
                </p>

                <!-- Колонка статуса -->
                <component-is-status
                  v-if="col.renderer === 'status' && rowIndex !== showHelperIndex"
                  :obj="row.items[row.items.length - 1]"
                />
                <!-- Колонка дат -->
                <component-prepare-date
                  v-else-if="col.renderer === 'date' && rowIndex !== showHelperIndex"
                  :timestamp="row.items[row.items.length - 1][col.tag]"
                />
                <!-- Колонка с прогрессом -->
                <component-percent
                  v-else-if="col.renderer == 'progress' && rowIndex !== showHelperIndex"
                  :percent="row.items[row.items.length - 1][col.tag]"
                />
                <!-- Колонка с информацией -->
                <a-button
                  v-else-if="col.renderer === 'info'"
                  type="primary"
                  size="small"
                  @click="openModal('general', row.items)"
                >
                  Подробнее
                </a-button>
                <!-- Колонка с действиями -->
                <component-column-actions
                  v-else-if="col.renderer === 'actions' && rowIndex !== showHelperIndex"
                  :data="row"
                  :disabled="
                    row.date === lastRestartedDate || row.items[row.items.length - 1].disabled
                  "
                  @clickStop="clickStop($event.items[$event.items.length - 1])"
                  @clickRestart="clickRestart($event.items[$event.items.length - 1])"
                />
                <!-- Колонка остальное -->
                <p v-else-if="rowIndex !== showHelperIndex" class="file-page__column-text">
                  {{ row.items[row.items.length - 1][col.tag] }}
                </p>
              </div>
            </div>

            <!-- Открывающаяся строка -->
            <div v-if="showHelperIndex === rowIndex" class="file-page__helper-row">
              <component-helper-row
                v-for="(helperRow, indexHelperRow) in row.items"
                :key="indexHelperRow"
                :obj="helperRow"
                :columns="tableHeader"
                :index="indexHelperRow"
                @openModal="openModal('child', $event)"
                @clickStop="clickStop($event)"
                @clickRestart="clickRestart($event)"
              />
            </div>
          </div>
        </div>
      </div>
    </page-block>
    <!-- Модальное окно -->

    <component-modal
      :show="showModal"
      :data="modalData"
      :type="typeModal"
      :showExportBtn="showExportModel"
      :config="appConfig"
      @closeModal="showModal = false"
    />
  </the-page>
</template>

<script>
import ThePage from '@/components/page/ThePage.vue';
import PageBlock from '@/components/page/PageBlock.vue';
import Mixin from './mixins/mixinProcessingPage.js';
import store from '@/store';

export default {
  name: 'TheProcessingPage',

  mixins: [Mixin],

  components: {
    ThePage,
    PageBlock,
    ComponentModal: () => import('./components/CustomModal.vue'),
    ComponentPrepareDate: () => import('./components/PrepareDate.vue'),
    ComponentIsStatus: () => import('./components/IsStatus.vue'),
    ComponentColumnActions: () => import('./components/ColumnActions.vue'),
    ComponentSelects: () => import('./components/Selects.vue'),
    ComponentPercent: () => import('./components/PreparePercent.vue'),
    ComponentHelperRow: () => import('./components/Journal/HelperRow.vue'),
    IconVektorToRight: () => import('@/assets/svg/icon-vektor-to-right.svg'),
  },

  props: {
    appConfig: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      showHelperIndex: null,
      type: 'table',
      old_data: null,
      data: null,
      columns: [
        { title: 'Дата' },
        { title: 'Название' },
        { title: 'Статус' },
        { title: 'Начало загрузки' },
        { title: 'Конец загрузки' },
        { title: 'Информация о загрузке' },
      ],
    };
  },

  computed: {
    showExportBtn() {
      return (
        store.state.activeSidebarItem?.parent?.title === 'Обработка данных' &&
        (store.state.activeSidebarItem?.title === 'Журнал обработки данных' ||
          store.state.activeSidebarItem?.title === 'Журнал машинного обучения')
      );
    },
    showExportModel() {
      return store.state.activeSidebarItem?.title === 'Журнал машинного обучения';
    },
  },

  methods: {
    openHelper(index) {
      if (this.showHelperIndex === index) {
        this.showHelperIndex = null;
      } else {
        this.showHelperIndex = index;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.file-page {
  &__table {
    height: 100%;
    width: 100%;
    padding: 12px;
    background: #ffffff;
    border-radius: $borderRadius;
  }

  &__table-header {
    width: 100%;
    display: flex;
    border: 1px solid darken($color: white, $amount: 15%);
    border-radius: $borderRadius $borderRadius 0 0;
    background-color: $colorBoxTable;
  }

  &__table-body {
    height: 85%;
    @include scrollbars();
    overflow-y: scroll;
  }

  &__column {
    width: 100%;
    overflow: hidden;
  }

  &__column-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: default;
    padding: 0;
    margin: 0;
  }

  &__table-header-title {
    width: 100%;
    padding: 18px 20px;
    font-weight: bold;
    font-size: 13px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    border-right: 1px solid darken($color: white, $amount: 15%);
    cursor: default;

    &:last-child {
      border-right: none;
    }
  }

  &__wrap-icon {
    max-width: 35px;
    min-width: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    align-self: stretch;
    border-right: 1px solid darken($color: white, $amount: 15%);
    cursor: pointer;
  }

  &__table-row {
    background: #ffffff;
    border-right: 1px solid darken($color: white, $amount: 15%);
    border-left: 1px solid darken($color: white, $amount: 15%);
    border-bottom: 1px solid darken($color: white, $amount: 15%);

    &:last-child {
      border-radius: 0 0 $borderRadius $borderRadius;
    }
  }

  &__row-content {
    display: flex;
    width: 100%;
  }

  &__column {
    width: 100%;
    display: flex;
    align-items: center;
    border-right: 1px solid darken($color: white, $amount: 15%);
    padding: 18px 20px;
    font-size: 13px;

    &:last-child {
      border-right: none;
    }
  }

  &__icon-vektor {
    width: 5px;
    height: 10px;

    &_rotate {
      transform: rotate(90deg);
    }
  }

  //.file-page__table {
  //  .status,
  //  .info,
  //  .date,
  //  .name {
  //    width: 150px;
  //  }
  //
  //  .date1,
  //  .date2 {
  //    width: 200px;
  //  }
  //
  //  .translate_name,
  //  .category {
  //    width: 310px;
  //  }
  //
  //  .ant-progress-outer {
  //    width: 70% !important;
  //  }
  //}
}
</style>
